import React from 'react';
import style from './style.scss'

const Instructions = (props) => {
    const {item, field} = props;
    return (
        <div className={style.typeInstructions}>
            <p>
                {field.label}
                {/* {item.render.message} */}
            </p>

        </div>
    )
}

export default Instructions;
